import BaseService from "../shared/services/BaseService";
import CONFIG from '@/config/config';

class VOpsService extends BaseService {
    URL_CONFIG = `${this.baseURL}`;
    url = this.URL_CONFIG + "/api/compile";
    path = "modifyZimletPrefsRequest";

    pathCreateTeamVOps = '/v1/proxy/createTeam'
    pathRoomUploadVOps = '/v1/proxy/roomUpload'
    pathSearchSpotlightVOps = '/v1/proxy/spotlightV1'
    pathSearchRoomVOps = '/v1/proxy/searchRoom'
    pathValidMemberVOps = '/v1/proxy/validMember'
    pathVerifyRoomVOps = '/v1/proxy/verifyRoom'
    pathFindTeamChatByEmailId = '/v1/proxy/findTeamChatByEmailId'
    
    constructor() {
        super("vOpsService");
        const configUrlCompileService = CONFIG.ENDPOINT["compileService"];
        const origin = window.location.origin;
        if (configUrlCompileService.startsWith('http')) {
            this.baseURLCompileService = configUrlCompileService;
        } else {
            this.baseURLCompileService = origin + configUrlCompileService;
        }
    }

    async validMemberVops(data ) {
        const url = `${this.baseURLCompileService}${this.pathValidMemberVOps}`;
        return this.postRequestVOps(url, data);
    }
    async createTeamVOps(data ) {
        const url = `${this.baseURLCompileService}${this.pathCreateTeamVOps}`;
        return this.postRequestVOps(url, data);
    }
    async roomUploadVOps(data, id) {
        const url = `${this.baseURLCompileService}${this.pathRoomUploadVOps}/${id}`;
        return this.postRequestVOps(url, data, false);
    }

    async searchSpotlightVOps(data) {
        const url = `${this.baseURLCompileService}${this.pathSearchSpotlightVOps}`;
        return this.postRequestVOps(url, data, false);
    }
    async verifyRoomUploadVOps(data) {
        const url = `${this.baseURLCompileService}${this.pathVerifyRoomVOps}`;
        return this.postRequestVOps(url, data);
    }
    async searchRoomVOps(data ) {
        const url = `${this.baseURLCompileService}${this.pathSearchRoomVOps}`;
        return this.postRequestVOps(url, data);
    }

    async findTeamChatByEmailIdVOps(data ) {
        const url = `${this.baseURLCompileService}${this.pathFindTeamChatByEmailId}`;
        return this.postRequestVOps(url, data);
    }

    handleJsonToString(obj) {
        return JSON.stringify(obj);
    }

    createFolderRequest(form) {
        const url = `${this.baseURL}/${this.pathCreateTeamVOps}`;
        return this.postRequest(url, form, true, false);
    }


    async saveTest(data = []) {
        const url = `${this.baseURL}/modifyZimletPrefsRequest`;
        const request = data
            .map(
                item =>
                    `<urn1:zimlet name='${item.name}' presence='${item.presence}'/>`
            )
            .join("");
        return this.postRequest(url, {
            zimlet: request
        });
    }

    async saveZimletYahoo(data) {
        const url = `${this.baseURL}/modifyPropertiesRequest`;
        const request = `<prop zimlet="com_zimbra_ymemoticons" name="yemoticons_enableInMail">${data}</prop>`;
        return this.postRequest(url, {
            zimlet: request
        });
    }
}
export default new VOpsService();
